module.exports = __webpack_public_path__ + "static/img/PULSE3.bed73c32.jpg";